import { render, staticRenderFns } from "./TeamPainWidget.vue?vue&type=template&id=535ef540"
import script from "./TeamPainWidget.vue?vue&type=script&lang=js"
export * from "./TeamPainWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports